import React, { ReactChild } from 'react';

export namespace SectionContentSubTitleTypes {
  export interface ISectionSubTitle {
    RenderAs?: TSectionRenderAs;
    children: ReactChild | React.ReactNode[];
  }
  export type TSectionRenderAs = 'h6' | 'p' | 'span';
}
